export default "__VITE_ASSET__HzgP$Dbz__"